var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',[_vm._v(" Edit Projects ")]),_c('ProjectFrom',{attrs:{"project":_vm.project,"type":"UPDATE"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }